export const DOCUMENT_ACCEPT =
  ".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf";

export function isImageFile(file: File) {
  return (
    file.type.startsWith("image/") ||
    /\.(png|jpe?g|gif|webp|bmp|svg|avif|heic)$/i.test(file.name)
  );
}

export function isVideoFile(file: File) {
  return (
    file.type.startsWith("video/") ||
    /\.(mp4|mov|webm|avi|mkv|m4v)$/i.test(file.name)
  );
}

export function isDocumentFile(file: File) {
  const name = file.name.toLowerCase();
  return (
    name.endsWith(".pdf") ||
    name.endsWith(".doc") ||
    name.endsWith(".docx") ||
    file.type === "application/pdf" ||
    file.type === "application/msword" ||
    file.type ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  );
}

export function collectFilesFromDataTransfer(
  data: DataTransfer | null | undefined
): File[] {
  if (!data) return [];
  const fromList = Array.from(data.files ?? []);
  if (fromList.length) return fromList;

  const fromItems: File[] = [];
  if (data.items) {
    for (let i = 0; i < data.items.length; i++) {
      const item = data.items[i];
      if (item.kind !== "file") continue;
      const file = item.getAsFile();
      if (file) fromItems.push(file);
    }
  }
  return fromItems;
}
